import $ from "jquery";

function updateCancelOption(statusSelect, cancelEmailOption) {
  if (statusSelect.value === "cancelled") {
    cancelEmailOption.classList.remove("display-none");
  } else {
    cancelEmailOption.classList.add("display-none");
  }
}

document.addEventListener("turbolinks:load", () => {
  $(document).on("click", ".js-thumb-input-container", function () {
    const input = $(this).find(".js-rating-input")[0];

    if (input) {
      input.checked = true;
      if (input.form) {
        input.form.requestSubmit();
      }
    }
  });

  // STATUS SELECT LOGIC
  var statusSelect = document.querySelector("#app_meeting_status");

  if (statusSelect) {
    // Cancel email option
    var cancelEmailOption = document.querySelector("#cancel-email-option");
    if (cancelEmailOption) {
      updateCancelOption(statusSelect, cancelEmailOption);
      statusSelect.addEventListener("change", () => {
        updateCancelOption(statusSelect, cancelEmailOption);
      });
    }
  }

  // EDIT COMMENT JS
  const commentContainers = document.querySelectorAll(".js-comment-container");
  commentContainers.forEach((container) => {
    const preview = container.querySelector(".js-comment-preview");
    const edit = container.querySelector(".js-comment-edit");
    const form = container.querySelector("form");
    const input = container.querySelector(".js-comment-input");

    // Show edit box when clicking the preview
    preview.addEventListener("click", (e) => {
      e.stopPropagation();
      preview.classList.add("hidden");
      edit.classList.remove("hidden");
      input.focus();
    });

    // Handle clicking outside to save
    document.addEventListener("click", (e) => {
      if (!edit.contains(e.target) && !preview.contains(e.target)) {
        if (!edit.classList.contains("hidden")) {
          form.requestSubmit();
        }
      }
    });

    // Handle Enter key to save
    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        form.requestSubmit();
      }
    });
  });

  // ARRIVED CHECKBOX JS
  // Handle arrival status checkbox toggle
  $(document).on("change", ".js-arrived-checkbox", function () {
    const $checkbox = $(this);

    // Disable checkbox to prevent double clicks
    $checkbox.prop("disabled", true);

    this.closest("form").requestSubmit();
  });

  // TIME SLOT LOGIC
  const timeSlotSelect = $("#app_meeting_app_time_slot_id");
  const notificationContainer = $("#time-slot-overlap-notification");
  const statusSelectEl = $("#app_meeting_status");

  // Time slot required for accepted status
  if (timeSlotSelect.length && statusSelectEl.length) {
    const updateRequired = () => {
      timeSlotSelect[0].required = statusSelectEl.val() === "accepted";
    };
    updateRequired();
    statusSelectEl.on("change", updateRequired);
  }

  // Time slot overlap detection
  if (timeSlotSelect.length && notificationContainer.length) {
    // Get time slots data from the page
    const programTimeSlots = window.programTimeSlotsData || [];
    const meetingTimeSlotsMap = window.meetingTimeSlotsMap || {};

    // Check for overlap with presentation time slots
    const checkOverlapWithPrograms = (selectedTimeSlotId) => {
      // Get the selected slot's time data from the map
      const selectedSlot = meetingTimeSlotsMap[selectedTimeSlotId];

      if (!selectedSlot) {
        hideNotification();
        return;
      }

      const selectedStartTime = new Date(selectedSlot.starts_at);
      const selectedEndTime = new Date(selectedSlot.ends_at);

      // Find presentation time slots that overlap with the selected slot
      const overlappingPrograms = programTimeSlots.filter((slot) => {
        const slotStartTime = new Date(slot.starts_at);
        const slotEndTime = new Date(slot.ends_at);

        // Check if the time slots overlap
        return (
          selectedStartTime < slotEndTime && selectedEndTime > slotStartTime
        );
      });

      if (overlappingPrograms.length > 0) {
        showNotification(overlappingPrograms[0]);
      } else {
        hideNotification();
      }
    };

    // Show notification
    const showNotification = (slot) => {
      const slotData =
        slot.speakers.length > 0
          ? `${slot.speakers}, "${slot.title}"`
          : slot.title;
      const message = `Huomaa, että valittu aika menee päällekkäin ohjelman kanssa: ${slotData}`;
      notificationContainer.html(
        `<div class="alert alert-warning" role="alert">${message}</div>`,
      );
      notificationContainer.show();
    };

    // Hide notification
    const hideNotification = () => {
      notificationContainer.hide();
    };

    // Check overlap when time slot selection changes
    timeSlotSelect.on("change", function () {
      const selectedValue = $(this).val();
      checkOverlapWithPrograms(selectedValue);
    });

    // Check overlap on page load if a time slot is already selected
    const initialValue = timeSlotSelect.val();
    if (initialValue) {
      checkOverlapWithPrograms(initialValue);
    }
  }
});
